import React from "react";
import { ImagePath } from "../../../assets/ImagePath";
import ChangePassword from "./Content";
import AuthLayout from "../../../components/layout/AuthLayout";


const ChangePasswordPage = () => {
  return (
    <AuthLayout
      LeftComponent={ChangePassword}
      rightBgImage={ImagePath.changePasswordBanner}
    />
  );
};

export default ChangePasswordPage;